import { Box, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import React from 'react';
import { IHomeDisplayStyle } from '../../../services/types';
import useStyles from './styles';

interface IProps {
  displayStyleList: IHomeDisplayStyle[] | undefined;
}

const DisplayStyleList = (props: IProps): JSX.Element => {
  const classes = useStyles();

  if (props.displayStyleList && props.displayStyleList.length === 0) {
    return (
      <Paper>
        <Box display="flex" justifyContent="center" alignItems="center" className={classes.noDataBox} flexDirection="column">
          <Typography>No data</Typography>
          <Typography variant="caption">{'Tap the "Create Display Style" at the top to create a first display style.'}</Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <div className={classes.root}>
      <Paper>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell align="center">ID</TableCell>
              <TableCell align="center">Style Title</TableCell>
              <TableCell align="center">Style Type</TableCell>
              <TableCell align="center">Shape</TableCell>
              <TableCell align="center"># of Display</TableCell>
              <TableCell align="center">Collections</TableCell>
              <TableCell align="center">Version</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.displayStyleList &&
              props.displayStyleList.map(style => {
                return (
                  <TableRow key={`style-table-row-${style.id}`}>
                    <TableCell align="center">{style.id}</TableCell>
                    <TableCell align="center">{style.title}</TableCell>
                    <TableCell align="center">{style.type}</TableCell>
                    <TableCell align="center">{style.shape}</TableCell>
                    <TableCell align="center">{style.numberOfDisplay}</TableCell>
                    <TableCell align="center">{style.collectionNumber}</TableCell>
                    <TableCell align="center">{style.requiredVersion}</TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
};

export default DisplayStyleList;
